import Vue from "vue";
import Vuex from "vuex";
import {billing} from "./modules/billing";
import rooms from "./modules/rooms";
import meeting from "./modules/meeting";
import meetings from "./modules/meetings";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // show/hide modals
        show_modal: false,
        modal_dismiss: true,
        // shown modals name
        shown_modal_name: "",
        user: null,
        user_maximized: false,
        // User room -> room ID of selceted transcript
        active_video_id: null,
        // selcted room transcripts
        transcripts: null,
        // Room ID for record remove modal
        record_remove_room_id: null,
        // record ID for record remove modal
        record_remove_id: null,
        // record video id for modal
        record_video_id: null,
        // show notification
        show_notification: false,
        // notification types {'', 'alert', 'succes'}
        notification_type: null,
        // notification content
        notification_content: "",
        // header Height
        header_heigth: 64,
        // tile heigth
        tile_heigth: "",
        // tile heigth
        tile_width: "",
        // tile max heigth
        tile_max_heigth: "",
        // tile max width
        tile_max_width: "",
        // show mobile exit pop up
        mobile_exit_pop_up: false,

        // show mobile reaction pop up
        mobile_reaction_pop_up: false,

        // is user logged in
        userAuthenticated: false,
    },

    mutations: {
        setUserAuthenticated(state, value) {
            state.userAuthenticated = value;
        },

        showMobileReactionPopUp(state, value) {
            state.mobile_reaction_pop_up = value;
        },

        showMobileExitPopUp(state, value) {
            state.mobile_exit_pop_up = value;
        },

        setTileMaxHeigth(state, value) {
            state.tile_max_heigth = value;
        },

        setTileMaxWidth(state, value) {
            state.tile_max_width = value;
        },

        setTileHeigth(state, value) {
            state.tile_heigth = value;
        },

        setTileWidth(state, value) {
            state.tile_width = value;
        },

        setHeaderHeigth(state, value) {
            state.header_heigth = value;
        },

        maximizeUserCallArea(state) {
            state.user_maximized = true;
        },

        minimizeUserCallArea(state) {
            state.user_maximized = false;
        },

        showModal(state, args) {
            let dismiss
            let name

            if (typeof args === "object") {
                [name, dismiss] = args
            } else {
                dismiss = true
                name = args
            }

            state.modal_dismiss = dismiss
            state.show_modal = true;
            state.shown_modal_name = name;
            document.body.classList.add("no_scroll");
        },

        hideModal(state, force) {
            if (!force && !state.modal_dismiss) return

            state.modal_dismiss = true
            state.show_modal = false;
            state.shown_modal_name = "";
            document.body.classList.remove("no_scroll");
        },

        showNotification(state, type) {
            state.show_notification = true;
            state.notification_type = type;
        },

        notificationContent(state, content) {
            state.notification_content = content;
        },

        hideNotification(state) {
            state.show_notification = false;
            state.notification_type = "";
            state.notification_text = "";
        },

        setUser(state, user) {
            state.user = user;
        },

        setUserTranscript(state, transcripts) {
            state.transcripts = transcripts;
        },

        setActiveVideoId(state, id) {
            state.active_video_id = id;
        },

        setActiveTranscript(state, transcript_id) {
            state.active_transcript = transcript_id;
        },

        setRecordRemoveRoom(state, id) {
            state.record_remove_room_id = id;
        },

        setRecordRemoveid(state, id) {
            state.record_remove_id = id;
        },

        setRecordVideoId(state, id) {
            state.record_video_id = id;
        },

        onShowError() {
        },
        onHideError() {
        },
        onShowSuccess() {
        },
        onHideSuccess() {
        },
    },

    actions: {
        onInfo(context, message) {
            context.commit("notificationContent", message);
            context.commit("showNotification", "info");
        },
        onSuccess(context, message) {
            context.commit("notificationContent", message);
            context.commit("showNotification", "succes");
        },
        onError({commit}, error) {
            const data = error.response?.data

            if (data?.reason === "upgrade-required") {
                return commit("showModal", "unlock_features");
            }

            const message =
                data?.message || error.message || "An error occurred";

            commit("notificationContent", message);
            commit("showNotification", "alert");
        },
    },

    modules: {
        rooms: rooms,
        meetings: meetings,
        meeting: meeting,
        billing: billing,
    },
});
